<div class="d-flex justify-content-between">
  <div class="w-100 pe-2">
    <label class="form-text" [class.text-danger]="isInvalid">
      {{ 'general.start' | translate }}*
    </label>
    <nz-input-group>
      <nz-date-picker
        wilsonUseLocalizedDateFormat
        class="w-100 rounded-0"
        [nzStatus]="isInvalid ? 'error' : ''"
        [nzShowTime]="true"
        [nzDisabled]="selectedTransferType === TransferType.Previous"
        [(ngModel)]="selectedStartDateTime"
        [nzDisabledDate]="
          shiftTransferTimePickerHelperService.disabledStartDate
        "
        [nzDisabledTime]="
          shiftTransferTimePickerHelperService.disabledStartTime
        "
        [nzAllowClear]="false"
        (ngModelChange)="generateTransferDateTime()"
      ></nz-date-picker>
    </nz-input-group>
  </div>
  <div class="w-100 ps-2">
    <label class="form-text" [class.text-danger]="isInvalid">
      {{ 'general.end' | translate }}*
    </label>
    <nz-input-group>
      <nz-date-picker
        wilsonUseLocalizedDateFormat
        class="w-100 rounded-0"
        [nzStatus]="isInvalid ? 'error' : ''"
        [nzShowTime]="true"
        [nzDisabled]="selectedTransferType === TransferType.Next"
        [(ngModel)]="selectedEndDateTime"
        [nzDisabledDate]="shiftTransferTimePickerHelperService.disabledEndDate"
        [nzDisabledTime]="shiftTransferTimePickerHelperService.disabledEndTime"
        [nzAllowClear]="false"
        (ngModelChange)="generateTransferDateTime()"
      ></nz-date-picker>
    </nz-input-group>
  </div>
</div>
@if (isInvalid) {
  <label class="form-text text-danger">
    {{ 'page.shift_timeline.add_transfer.start_time_is_after_end' | translate }}
  </label>
}
